import React from "react";
import { Shield, ShieldCheck, AlertTriangle, CheckCircle2, Bot, Cpu, ArrowRight, Folder, Layers } from "lucide-react";

export default function HeroSection() {
  return (
    <section className="tfl-hero" aria-labelledby="hero-heading">
      {/* Background Polygon Glows & Cyber Grid Overlay */}
      <div className="tfl-hero__grid-bg" aria-hidden="true" />
      <div className="tfl-blob tfl-hero__blob-1" aria-hidden="true">
        <div className="tfl-blob__shape" />
      </div>
      <div className="tfl-blob tfl-hero__blob-2" aria-hidden="true">
        <div className="tfl-blob__shape" />
      </div>

      <div className="tfl-hero__grid">
        {/* ── Left Column: Editorial Copy ── */}
        <div className="tfl-hero__copy">
          <div className="tfl-hero__badge tfl-appear">
            <span className="tfl-hero__badge-pill">Sentry 2.0</span>
            <span>Next-Gen AI Threat Modeling Workspace</span>
          </div>

          <h1 className="tfl-hero__h1 tfl-appear-1" id="hero-heading">
            Threat modeling,<br />
            <em>revisable at the speed of code.</em>
          </h1>

          <p className="tfl-hero__sub tfl-appear-2">
            Decompose complex architectures, synthesize STRIDE &amp; PASTA threat catalogs in seconds, simulate attack vectors with dynamic trees, and generate audit-ready compliance reports.
          </p>

          <div className="tfl-hero__ctas tfl-appear-3">
            <a href="/signup" className="tfl-btn tfl-btn--primary">
              <span>Get Started Free</span>
              <ArrowRight size={15} />
            </a>
            <a href="/book-demo" className="tfl-btn tfl-btn--ghost">
              <span>Book a Demo</span>
              <ArrowRight size={15} />
            </a>
          </div>
        </div>

        {/* ── Right Column: Actual ThreatForge Workspace Header Image ── */}
        <div className="tfl-hero__visual tfl-appear-4">
          <img
            src="/assets/header.png"
            alt="ThreatForge Application Workspace Header"
            className="tfl-hero__img"
          />
        </div>
      </div>
    </section>
  );
}
